import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ModalWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgb(255, 255, 255);
  border-radius: 8px;
  outline: none;
  width: 90vw;
  min-height: 80vh;
  max-width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;

  @media (min-width: 600px) {
    width: 80vw;
    min-height: 80vh;
  }

  @media (min-width: 960px) {
    width: 70vw;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
export const ModalHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitleContainer = styled.div`
  flex: 1;
`;

export const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

export const ModalDescription = styled.p`
  font-size: 0.875rem;
  color: #64748b;
  margin: 4px 0 0 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #64748b;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f1f5f9;
    color: #1e293b;
  }
`;

export const ModalContent = styled.div`
  padding: 24px;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;

  @media (max-width: 600px) {
    padding: 12px 16px;
  }
`;

export const StepperContainer = styled.div`
  margin-bottom: 24px;
`;

export const StepperWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const StepItem = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const StepNumber = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.active ? '#293778' : '#e2e8f0'};
  color: ${(props) => (props.active ? 'white' : '#64748b')};
  font-weight: 500;
  margin-right: 8px;
`;

export const StepLabel = styled.div`
  font-weight: 500;
  color: #1e293b;
`;

export const StepDivider = styled.div`
  flex: 1;
  height: 2px;
  background-color: #e2e8f0;
  margin: 0 8px;

  @media (max-width: 600px) {
    display: none;
  }
`;
export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  background-color: #293778;
  border-radius: 4px;
  transition: width 0.3s ease;
  width: ${(props) => `${props.progress}%`};
`;
export const TabsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TabsList = styled.div`
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 16px;
`;

export const TabButton = styled.button<{ active: boolean }>`
  padding: 8px 16px;
  background: none;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${(props) => (props.active ? '#293778' : '#64748b')};
  cursor: pointer;
  border-bottom: 2px solid
    ${(props) => (props.active ? '#293778' : 'transparent')};
  transition: all 0.2s ease;

  &:hover {
    color: ${(props) => (props.active ? '#293778' : '#1e293b')};
  }
`;
export const SourcesStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
`;

export const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  display: flex;
  align-items: center;
`;

export const SectionHeading = styled.h3`
  font-size: 1.125rem;
  font-weight: 500;
  color: #1e293b;
  margin: 0 0 16px 0;
`;

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
`;

export const StepContent = styled(motion.div)`
  width: 100%;
  flex: 1;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  position: absolute;
`;
export const RiskContainer = styled.div`
  .radio-group {
    display: flex;
    align-items: center;

    .label {
      display: flex;
      align-items: center;
    }

    .icon-high {
      color: #f44336;
      width: 15px;
      margin-right: 5px;
    }

    .icon-medium {
      color: #ff9800;
      width: 15px;
      margin-right: 5px;
    }

    .icon-low {
      color: #4caf50;
      width: 15px;
      margin-right: 5px;
    }
  }
`;
